export const privacy = {
  it: {
    title: "Informativa sulla Privacy",
    section1: {
      title: "1. Titolare del trattamento",
      content: "Il titolare è Victor Lazari – Varienda BMS, con sede operativa a Ravenna (RA), Italia. Puoi contattarci per qualsiasi richiesta privacy all’indirizzo victor@victorlazari.com o al numero +39 380 633 1704."
    },
    section2: {
      title: "2. Dati personali raccolti",
      content: "Trattiamo soltanto le informazioni necessarie per erogare i servizi Foundation/Launch e gestire le richieste provenienti da questo sito:",
      items: [
        "Dati di contatto e lead (nome, email, telefono, azienda, ruolo) raccolti tramite form di contatto, chatbot AI (Victor AI) o WhatsApp Business",
        "Credenziali e metadati degli account CRM Lite (piano Launch): contatti, lead, appuntamenti, note, attività",
        "Indirizzi e coordinate geografiche (Google Maps URL) per la funzionalità Navigator nel CRM",
        "Contenuti delle conversazioni con il chatbot AI e interazioni WhatsApp Business",
        "Log applicativi, audit trail e telemetria necessari alla sicurezza e al funzionamento del sistema",
        "Preferenze commerciali, note su ticket e interazioni di supporto",
        "Dati Microsoft 365 (email, calendario, file cloud) per i servizi inclusi nei piani"
      ]
    },
    section3: {
      title: "3. Finalità e basi giuridiche",
      content: "Trattiamo i dati nel rispetto del GDPR e delle basi giuridiche pertinenti:",
      items: [
        "Esecuzione di misure precontrattuali e contrattuali (configurazione sito web, CRM Lite, onboarding, fatturazione, gestione Google Business Profile)",
        "Erogazione dei servizi inclusi nei piani (Microsoft 365, automazioni WhatsApp, workflow n8n, gestione social)",
        "Adempimento di obblighi legali e fiscali",
        "Legittimo interesse alla prevenzione di frodi, sicurezza infrastrutturale e miglioramento del servizio",
        "Consenso espresso per newsletter, utilizzo di testimonianze e materiali di marketing",
        "Consenso implicito per l'utilizzo del chatbot AI e la raccolta di informazioni di contatto per finalità commerciali"
      ]
    },
    section4: {
      title: "4. Origine dei dati e fornitori esterni",
      content: "I dati sono raccolti direttamente dall'interessato tramite form di contatto, chatbot AI, WhatsApp Business o importati manualmente nel CRM. Per l'erogazione dei servizi ci avvaliamo di fornitori cloud che agiscono come responsabili ex art. 28 GDPR:",
      items: [
        "Supabase (hosting applicativo, database e autenticazione con data center UE/USA)",
        "Microsoft 365 (email, calendario, cloud storage OneDrive, suite Office via Web)",
        "Anthropic / OpenAI (chatbot AI Victor AI con modelli Claude/GPT)",
        "WhatsApp Business API (automazioni 24/7 e gestione messaggi)",
        "n8n (workflow automation e integrazioni)",
        "Leaflet/OpenStreetMap (funzionalità Navigator nel CRM - dati di mappatura, non dati personali)",
        "Provider di posta transazionale e analytics (ad es. Microsoft Graph, Vercel Analytics)"
      ]
    },
    section5: {
      title: "5. Tempi di conservazione",
      content: "Conserviamo i dati solo per il tempo strettamente necessario:",
      items: [
        "Richieste commerciali e lead da chatbot: fino a 24 mesi dall'ultima interazione",
        "Dati CRM (contatti, lead, appuntamenti): per la durata del contratto e fino a 12 mesi successivi per finalità di audit",
        "Dati di account e log applicativi: per la durata del contratto e fino a 12 mesi successivi per finalità di audit",
        "Conversazioni chatbot AI: fino a 12 mesi dalla data della conversazione",
        "Dati Microsoft 365: secondo i termini del servizio Microsoft 365 incluso nel piano",
        "Documentazione fiscale: secondo gli obblighi civilistici e tributari italiani",
        "Dati trattati su base di consenso: fino a revoca"
      ]
    },
    section6: {
      title: "6. Misure di sicurezza",
      content: "Adottiamo misure tecniche e organizzative adeguate a tutelare le informazioni, tra cui:",
      items: [
        "Crittografia in transito (TLS) e a riposo sui provider che lo consentono (Supabase, Microsoft 365)",
        "Autenticazione a più fattori per accesso CRM e segregazione degli ambienti demo/produzione",
        "Policy di accesso basate su ruoli (owner, admin, agent, viewer) e Row Level Security in Supabase",
        "Monitoraggio delle integrazioni Microsoft 365, WhatsApp Business API, AI e logging degli accessi",
        "Backup automatici dei dati CRM e configurazioni",
        "Gestione sicura delle credenziali e token di autenticazione"
      ]
    },
    section7: {
      title: "7. Diritti degli interessati",
      content: "Ai sensi degli artt. 15–22 GDPR puoi:",
      items: [
        "Ottenere conferma e copia dei dati trattati",
        "Chiedere rettifica, cancellazione o limitazione",
        "Opporsi al trattamento in presenza di motivi legittimi",
        "Ottenere la portabilità dei dati forniti",
        "Revocare in qualsiasi momento il consenso prestato",
        "Presentare reclamo al Garante per la protezione dei dati personali"
      ]
    },
    section8: {
      title: "8. Cookie e strumenti di tracciamento",
      content: "Utilizziamo cookie tecnici necessari al funzionamento del sito e strumenti di analytics anonimizzati per misurare traffico e campagne. Puoi gestire le preferenze tramite il banner cookie o le impostazioni del browser."
    },
    section9: {
      title: "9. Trasferimenti extra UE e garanzie",
      content: "Alcuni fornitori (es. Supabase, Anthropic, OpenAI) possono elaborare dati in Paesi extra UE. In questi casi adottiamo clausole contrattuali standard, audit di sicurezza e minimizzazione dei dataset per tutelare i diritti degli utenti.",
      contact: {
        title: "Come contattarci",
        email: "victor@victorlazari.com",
        phone: "+39 380 633 1704",
        address: "Ravenna (RA), Italia"
      }
    },
    section10: {
      title: "10. Aggiornamenti dell'informativa",
      content: "Questa informativa può essere aggiornata per riflettere cambi normativi o evoluzioni del servizio. In caso di modifiche sostanziali notificheremo gli interessati attraverso il sito o via email."
    },
    lastUpdated: "Ultimo aggiornamento: Settembre 2025"
  },
  en: {
    title: "Privacy Policy",
    section1: {
      title: "1. Data controller",
      content: "The controller is Victor Lazari – Varienda BMS, operating out of Ravenna (Italy). For privacy inquiries contact victor@victorlazari.com or call +39 380 633 1704."
    },
    section2: {
      title: "2. Personal data we collect",
      content: "We only process the information required to deliver Foundation/Launch services and to answer requests from this website:",
      items: [
        "Contact and lead details (name, email, phone, company, role) collected via contact forms, AI chatbot (Victor AI) or WhatsApp Business",
        "Account credentials and metadata for Lite CRM (Launch plan): contacts, leads, appointments, notes, activities",
        "Addresses and geographic coordinates (Google Maps URLs) for Navigator functionality in CRM",
        "AI chatbot conversation content and WhatsApp Business interactions",
        "Application logs, audit trails and telemetry used for security and system operation",
        "Commercial preferences, help-desk notes and support interactions",
        "Microsoft 365 data (email, calendar, cloud files) for services included in plans"
      ]
    },
    section3: {
      title: "3. Purposes and lawful bases",
      content: "Processing is carried out in compliance with the GDPR on the following bases:",
      items: [
        "Performance of pre-contractual and contractual measures (website setup, Lite CRM, onboarding, invoicing, Google Business Profile management)",
        "Delivery of services included in plans (Microsoft 365, WhatsApp automations, n8n workflows, social management)",
        "Compliance with legal and tax obligations",
        "Legitimate interest in fraud prevention, infrastructure security and service improvement",
        "Explicit consent for newsletters, testimonials and optional marketing initiatives",
        "Implicit consent for AI chatbot usage and collection of contact information for commercial purposes"
      ]
    },
    section4: {
      title: "4. Sources and processors",
      content: "Data is collected directly from you via contact forms, AI chatbot, WhatsApp Business or manually imported into CRM. To deliver the service we rely on sub-processors acting under data processing agreements:",
      items: [
        "Supabase (application hosting, database and authentication in EU/US regions)",
        "Microsoft 365 (email, calendar, OneDrive cloud storage, Office suite via Web)",
        "Anthropic / OpenAI (Victor AI chatbot with Claude/GPT models)",
        "WhatsApp Business API (24/7 automations and message management)",
        "n8n (workflow automation and integrations)",
        "Leaflet/OpenStreetMap (Navigator functionality in CRM - mapping data, not personal data)",
        "Transactional email and analytics vendors (e.g. Microsoft Graph, Vercel Analytics)"
      ]
    },
    section5: {
      title: "5. Retention periods",
      content: "Data is kept only for the time strictly necessary:",
      items: [
        "Commercial enquiries and chatbot leads: up to 24 months from the last interaction",
        "CRM data (contacts, leads, appointments): for the contract duration plus up to 12 months for audit purposes",
        "Account data and audit logs: for the contract duration plus up to 12 months for audit purposes",
        "AI chatbot conversations: up to 12 months from the conversation date",
        "Microsoft 365 data: according to Microsoft 365 service terms included in the plan",
        "Accounting records: in line with Italian civil and tax obligations",
        "Consent-based processing: until consent is withdrawn"
      ]
    },
    section6: {
      title: "6. Security measures",
      content: "We implement appropriate technical and organisational safeguards, including:",
      items: [
        "Encryption in transit (TLS) and at rest where supported (Supabase, Microsoft 365)",
        "Multi-factor authentication for CRM access and separation of demo/production environments",
        "Role-based access control (owner, admin, agent, viewer) and Supabase Row Level Security",
        "Monitoring of Microsoft 365, WhatsApp Business API, AI integrations plus access logging",
        "Automatic backups of CRM data and configurations",
        "Secure management of credentials and authentication tokens"
      ]
    },
    section7: {
      title: "7. Data subject rights",
      content: "Under Articles 15–22 GDPR you can:",
      items: [
        "Request confirmation and access to the data we hold",
        "Ask for rectification, deletion or restriction",
        "Object to processing where legitimate grounds exist",
        "Receive data portability for information you provided",
        "Withdraw consent at any time",
        "Lodge a complaint with the Italian Data Protection Authority"
      ]
    },
    section8: {
      title: "8. Cookies and tracking",
      content: "We use essential cookies required for the website to operate and anonymised analytics to measure performance. Preferences can be managed through the cookie banner or browser settings."
    },
    section9: {
      title: "9. International transfers and safeguards",
      content: "Certain providers (e.g. Supabase, Anthropic, OpenAI) may process data outside the EEA. We rely on Standard Contractual Clauses, security audits and strict data minimisation to protect individuals' rights.",
      contact: {
        title: "Contact details",
        email: "victor@victorlazari.com",
        phone: "+39 380 633 1704",
        address: "Ravenna (RA), Italy"
      }
    },
    section10: {
      title: "10. Policy updates",
      content: "We may revise this privacy notice to reflect legal or service changes. Material updates will be announced via the website or email, with the effective date shown below."
    },
    lastUpdated: "Last updated: September 2025"
  }
};